import { Moment } from "moment"
import { Uuid } from "helpers/types/uuid"
import { IsoDate } from "helpers/types/dates"
import useResource from "hooks/resources"
import { useAccountAlias } from "resources/account"
import { ResourceResult } from "helpers/data-statuses"

export interface Portfolio {
  alias: string
  description: string
  fxHedgeEnabled: boolean
  id: Uuid
  intradayEnabled: boolean
  lastUpdated: IsoDate | null
  live: boolean
  modelId: string
  name: string
  shortId: string

  // These types not validated
  betaBenchmarkId: string | null
  betaIndexId: string | null
  betaResourceId: string | null
  betaResourceType: string | null
  betaSecurityId: string | null
  currencyOverride: string | null
}

export function usePortfolios(): ResourceResult<Portfolio[]> {
  const account = useAccountAlias()

  return useResource<Portfolio[]>({
    resource: "portfolios",
    url: () => account ? `/api/${account}/portfolios` : null,
  }, "portfolios")
}

export function useHasUnexpandedComposites(modelId: string, portfolioId: Uuid, currentDate: Moment, performanceStartDate?: Moment) {
  const startDate = performanceStartDate || currentDate
  const account = useAccountAlias()

  return useResource<boolean>({
    resource: "hasUnexpandedComposites",
    url: () => account && modelId && portfolioId && currentDate ? `/api/${account}/p/${portfolioId}/${modelId}/unexpanded-composites?from=${startDate.format("YYYY-MM-DD")}&to=${currentDate.format("YYYY-MM-DD")}` : null,
  }, "hasUnexpandedComposites")
}
